const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function resolvePhotoUrl(photo) {
    if (!photo) return null;
    if (photo.startsWith("http://") || photo.startsWith("https://")) return photo;
    const base = BACKEND_URL.replace(/\/$/, "");
    const path = photo.startsWith("/") ? photo : `/${photo}`;
    return `${base}${path}`;
}
